<!--快检指标设置-按品级-->
<template>
    <div class="quickCheckSettingGrade">
        <div class="header-con">
            <h4>快检指标设置</h4>
        </div>
        <div class="main-con">
            <slider @load-table="handleLoadTable"></slider>
            <RBtableList
                :current-data="'currentData'"
                ref="RBtableList"
            ></RBtableList>
        </div>
    </div>
</template>

<script>
import slider from './slider';
import RBtableList from './RBtableList';
export default {
    components: { slider, RBtableList },
    props: { },
    data() {
        return {
            isGrade: false, // 是否展示国标列表
            currentData: {}, // 当前树节点信息
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 加载表格
        handleLoadTable(data) {
            this.currentData = data;
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="stylus" scoped>
.quickCheckSettingGrade
    font-size 16px
    overflow hidden
    .header-con
        height 40px
        display flex
        background #fff
        margin-bottom 20px
        justify-content space-between
        line-height 40px
        padding 0 10px
        .save-btn
            width 60px
            height 28px
            text-align center
            background #1577D2
            border-radius 4px
            color #fff
            margin-top 6px
            line-height 28px
            cursor pointer
    .main-con
        height calc(100% - 60px)
</style>
